import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase'; // adjust the path to your firebase config if needed

const SkillBadge = ({ skill }) => {
  const [isBroken, setIsBroken] = useState(false);

  const skillMap = {
    'c++': 'cplusplus',
    'c#': 'csharp',
    'f#': 'fsharp',
    'node.js': 'nodejs',
  };

  const raw = skill.toLowerCase().trim();
  const normalized = skillMap[raw] || raw.replace(/\+/g, 'plus').replace(/\s/g, '');
  const iconUrl = `https://skillicons.dev/icons?i=${normalized}`;

  const alwaysFallback = ['cplusplus', 'csharp', 'fsharp'];

  return (
    <div className="d-flex align-items-center me-3 mb-2">
      {!isBroken && !alwaysFallback.includes(normalized) ? (
        <img
          src={iconUrl}
          alt={skill}
          style={{ height: '24px', marginRight: '6px' }}
          onError={() => setIsBroken(true)}
        />
      ) : (
        <span style={{ marginRight: '6px', color: '#fff' }}>{skill}</span>
      )}
    </div>
  );
};

const PublicPortfolio = () => {
  const [searchParams] = useSearchParams();
  const id = searchParams.get('id');
  const [data, setData] = useState(null);

  useEffect(() => {
  const fetchPortfolio = async () => {
    if (!id) return;
    try {
      const docRef = doc(db, 'portfolios', id);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        setData(docSnap.data());
      } else {
        console.warn("No portfolio found for this ID.");
      }
    } catch (error) {
      console.error("Error fetching portfolio:", error);
    }
  };

  fetchPortfolio();
}, [id]);

  if (!data) {
  return (
    <div className="text-white text-center mt-5">
      <div className="spinner-border text-info" role="status"></div>
      <p>Loading portfolio...</p>
    </div>
  );
}


  return (
    <div
      className="d-flex flex-column min-vh-100 public-portfolio"
      style={{
        backgroundColor: data.themeColor || '#1a1a2e',
        color: '#fff',
        overflowWrap: 'break-word',
        wordBreak: 'break-word',
        wordWrap: 'break-word'
      }}
    >
      <div className="container">
        <div className="d-flex align-items-center mt-4 mb-3">
          {data.profileImage && (
            <img
              src={data.profileImage}
              alt="Profile"
              className="mb-3"
              style={{
                width: 140,
                height: 140,
                objectFit: 'cover',
                borderRadius: '50%',
                border: `3px solid ${data.imageBorderColor}`,
                boxShadow: `0 0 20px ${data.imageBorderColor}99`,
                marginRight: '1.5rem'
              }}
            />
          )}
          <h2 className="mt-3 text-white">{data.name || 'Developer Name'}</h2>
        </div>

        <p><em>{data.bio}</em></p>

        <h5>Skills:</h5>
        <div className="mb-3 d-flex flex-wrap">
          {data.skills.map((skill, i) => (
            <SkillBadge key={i} skill={skill} />
          ))}
        </div>

        <h5>Projects:</h5>
        {data.projects.map((proj, i) => (
          <div key={i} className="mb-3 d-flex align-items-start">
            <div
              className="project-badge me-2"
              style={{
                backgroundColor: proj.color || '#ff007f',
                boxShadow: `0 0 6px ${proj.color || '#ff007f'}`
              }}
            ></div>
            <div>
              <strong className="project-title">{proj.title}</strong>
              <p className="project-description">{proj.description}</p>
              {proj.link && (
                <a
                  href={proj.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-sm btn-outline-info"
                >
                  View Project
                </a>
              )}
            </div>
          </div>
        ))}

        <p className="mt-4"><strong>Contact:</strong> {data.contact}</p>
      </div>
    </div>
  );
};

export default PublicPortfolio;
